import React from "react";
import {Pjdb1ButtonProps} from "../../../../components/inputs/Pjdb1Button";
import {ObjectDocument} from "../../../../types/pj1dbApiObject";
import DownloadFileButton from "./DownloadFileButton";

interface DownloadObjectFileButtonProps extends Partial<Pjdb1ButtonProps> {
  obj: ObjectDocument | null;
}

export default function DownloadObjectFileButton({obj, ...props}: DownloadObjectFileButtonProps) {
  const files = obj ? [
    {
      id: obj.attr["object-id"],
      signedUrls: obj?.url.urdf_pkg_root.converted_zip ?? []
    }
  ] : [];

  return (
    <DownloadFileButton
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
      baseFileName='object'
      label="オブジェクトのダウンロード"
      variant="contained"
      color="info"
      files={files}
      disabled={files.length === 0}
    />
  )
};
